module.exports = __webpack_public_path__ + "img/Utlandsbokningar.0e020397.jpg";